import { render, staticRenderFns } from "./AiTest.vue?vue&type=template&id=1d117fb5&scoped=true&"
import script from "./AiTest.vue?vue&type=script&lang=js&"
export * from "./AiTest.vue?vue&type=script&lang=js&"
import style0 from "./AiTest.vue?vue&type=style&index=0&id=1d117fb5&prod&lang=less&"
import style1 from "./AiTest.vue?vue&type=style&index=1&id=1d117fb5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d117fb5",
  null
  
)

export default component.exports